import React, { useMemo, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import UserInspectionProductDetail from "./UserInspectionProductDetail";
import {
  fromBmarkenDateToDateTime,
  fromBmarkenDateToDay,
  priceText,
} from "../utils/utils";

function safeTime(v) {
  if (!v) return 0;
  const t = new Date(v).getTime();
  return Number.isFinite(t) ? t : 0;
}

const updatedOrCreated = (item) => item?.updated_at || item?.created_at;

const decodeProductStatus = (status) => {
  const s = Number(status);
  switch (s) {
    case 0:
      return "Active";
    case 1:
      return "Inactive";
    case 2:
      return "Expired";
    case 3:
      return "Burned";
    case 4:
      return "Standby";
    case 5:
      return "Deleted";
    default:
      return "-";
  }
};

const isExpiredByDate = (expiration_date) => {
  if (!expiration_date) return false;
  const exp = new Date(expiration_date);
  const expMs = exp.getTime();
  if (!Number.isFinite(expMs)) return false;
  return expMs < Date.now();
};

// Forza Expired SOLO se: status==0 AND scadenza passata
const effectiveStatus = (item) => {
  const raw = Number(item?.status);
  if (raw === 0 && isExpiredByDate(item?.expiration_date)) return 2;
  return raw;
};

const cellStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export default function UserInspectionFidelityCards({
  cards,
  onShowTransactions,
}) {
  const [filterAttivi, setFilterAttivi] = useState(false);

  const filteredAndSorted = useMemo(() => {
    const list = [...(cards || [])];

    // Attivi => solo stato effettivo == 0
    const filtered = filterAttivi
      ? list.filter((c) => effectiveStatus(c) === 0)
      : list;

    filtered.sort((a, b) => safeTime(b.created_at) - safeTime(a.created_at));
    return filtered;
  }, [cards, filterAttivi]);

  return (
    <div style={{ width: "100%" }}>
      <Box mb={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={filterAttivi}
              onChange={(e) => setFilterAttivi(e.target.checked)}
              color="primary"
            />
          }
          label="Attivi"
        />
      </Box>

      <Box
        display="flex"
        alignItems="center"
        style={{
          padding: "8px 16px",
          borderBottom: "1px solid rgba(0,0,0,0.12)",
        }}
      >
        <Box flex={2} pr={2}>
          <Typography variant="h6">Creato</Typography>
        </Box>
        <Box flex={2} pr={2} style={{ textAlign: "right" }}>
          <Typography variant="h6">Punti</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Stato</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Scadenza</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Aggiornato</Typography>
        </Box>
        <Box width={40} />
      </Box>

      {filteredAndSorted.map((c, i) => {
        const creato = fromBmarkenDateToDay(c.created_at);
        const valore = priceText(c.available_value);
        const stato = decodeProductStatus(effectiveStatus(c));
        const scadenza = fromBmarkenDateToDay(c.expiration_date);
        const aggiornato = fromBmarkenDateToDateTime(updatedOrCreated(c));

        return (
          <Accordion key={c.id || i} square>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center" width="100%">
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{creato}</Typography>
                </Box>
                <Box
                  flex={2}
                  pr={2}
                  style={{ ...cellStyle, textAlign: "right" }}
                >
                  <Typography>{valore}</Typography>
                </Box>
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{stato}</Typography>
                </Box>
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{scadenza}</Typography>
                </Box>
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{aggiornato}</Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails style={{ display: "block" }}>
              <Box pl={4} pr={1} width="100%">
                <UserInspectionProductDetail
                  item={c}
                  onShowTransactions={onShowTransactions}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}
